/**
 * Gift toast notification.
 *
 * Shows a toast after a product is added to the cart:
 * - If the cart is below the gift threshold: "Noch X € bis zum gratis Dino-Roarr."
 * - If the cart reaches the threshold and the gift is added: "Dino-Roarr wurde gratis hinzugefügt."
 */
(() => {
  const script = document.currentScript;
  const variantId = String(script.dataset.variantId || '');
  const threshold = Math.round(parseFloat(script.dataset.threshold || '0') * 100);
  const productName = script.dataset.productName || 'Geschenk';

  if (!variantId || !threshold) return;

  let expectingGift = false;

  const getCart = async () => {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`);
    return response.json();
  };

  const hasGift = (cart) => cart.items.some((item) => String(item.variant_id) === variantId);

  const showToast = (message) => {
    document.dispatchEvent(new CustomEvent('toast:show', {
      detail: { message, duration: 3000 }
    }));
  };

  const formatMoney = (cents) => {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'EUR'
    });
  };

  document.addEventListener('cart:change', async (event) => {
    if (event.detail?.baseEvent !== 'variant:add') return;

    const cart = await getCart();
    const subtotal = cart.items_subtotal_price;

    if (hasGift(cart) || subtotal >= threshold) {
      expectingGift = true;
      return;
    }

    const remaining = threshold - subtotal;
    showToast(`Noch ${formatMoney(remaining)} bis zum gratis ${productName}.`);
  });

  document.addEventListener('cart:refresh', async () => {
    if (!expectingGift) return;
    expectingGift = false;

    const cart = await getCart();
    if (hasGift(cart)) {
      showToast(`${productName} wurde gratis hinzugefügt.`);
    }
  });
})();
